<div class="step-header">
  <div class="step-name">{{ step.stepName }}</div>
  <div class="step-number">{{ step.stepNumber }}</div>
  <div class="stepper-horizontal-line col-sm-3"></div>
</div>
